import BlogSection from "../components/blog/blog-section";
import BreadcrumbSection from "../components/blog/breadcrumb-section";

export default function Blog() {
	return (
		<>
			<BreadcrumbSection />
			<BlogSection />
		</>
	);
}
